import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
class getPreferencias extends Component {
  constructor(props){
    super(props);
    this.state = {
        preferencia : [],
        new_preferencia :''
    }
  }
  cargar_preferencias =()=>{
    const url= this.props.dir_url + "webapp/getDataPreferencias";
    const token =  this.props.token
    var obj = { accion:'datapreferencia', token};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        //console.log(data)
        this.setState({
          preferencia : data[0].msg
        })
      }
    })
    .catch(console.log)
  }
  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }

get_opcion_no =()=>{

}

getnewrPreferencia =()=>{
  const preferencia = this.state.new_preferencia.trim()
  if(preferencia===''){
    alert("Ingrese Nombre Preferencia")
    return
  }
  const url= this.props.dir_url + "webapp/getNewPreferencia";
  const token =  this.props.token
  var obj = { accion:'newpreferencia',token, preferencia};
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(obj),
    headers:{
      'Accept':'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(res => res.json())
  .then((data) => {
    this.props.get_loading(false)
    this.setState({
        new_preferencia :''
    },()=>{
      this.cargar_preferencias()
    })

  })
  .catch(console.log)
  this.props.get_loading(true)
}
///
getEliminarPreferencia=(id_acumulador)=>{
  confirmAlert({
    title: 'Eliminar Preferencia',
    message: '¿Desea Eliminar Preferencia?',
    buttons: [
      {
        label: 'Sí',
        onClick: () => {
          var preferencia = this.state.preferencia
          preferencia.forEach(det => {
            if(Number(det.id_acumulador)===Number(id_acumulador)){
                det.eliminado = 1;
            }
          });
          this.setState(
            {preferencia} , ()=>{
              this.getgrabarPreferencia(id_acumulador)
            }
          );

        }
      },
      {
        label: 'No',
        onClick: () => this.get_opcion_no()
      }
    ]
  })
}



  getgrabarPreferencia =(id_acumulador)=>{
    const array_preferencia= this.state.preferencia
    let preferencia
    let eliminado
    let id_preferencia

    array_preferencia.forEach(det => {
      if(Number(det.id_acumulador)===Number(id_acumulador)){
        preferencia = det.preferencia.trim()
        eliminado = det.eliminado
        id_preferencia = det.id_preferencia
      }
    });
    if(Number(id_preferencia)<=0){
      return null
    }
    if(preferencia===''){
      alert("Ingrese Nombre Preferencia")
      return
    }
    const url= this.props.dir_url + "webapp/getGrabarPreferencia";
    const token =  this.props.token
    var obj = { accion:'grabarpreferenciadata',token, id_preferencia,preferencia,eliminado};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.props.get_loading(false)
      this.cargar_preferencias()
    })
    .catch(console.log)
    this.props.get_loading(true)
  }

  handleChange_new = (event ,name) => {
    let value = event.target.value 
    if(name==="preferencia"){
      this.setState({
        new_preferencia: value
      })
    }
  }
  handleChange = (event , index ,name) => {
    var preferencia = this.state.preferencia
    let value = event.target.value

    preferencia.forEach(det => {
      if(Number(det.id_acumulador)===Number(index)){
        if(name==="preferencia"){
          det.preferencia = value;
        }
      }
    });
    this.setState({preferencia});
  }


  llenar_preferencias =()=>{
    const preferencia = this.state.preferencia
    return(
       <React.Fragment>
       <tbody>
        {
          (preferencia)?
          preferencia.map((det , index) => (
            <tr key={index}>
              <td>
              <table className="tb_pedidos">
                <thead>
                <tr>
                  <th>Campo</th>
                  <th>Valor</th>
                </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Id Preferencia</td>
                    <td>{det.id_preferencia}</td>
                  </tr>
                  <tr>
                    <td>Preferencia</td>
                    <td> <input  type="text" value={det.preferencia|| ''}
                      onChange={(e) => {this.handleChange( e , det.id_acumulador ,"preferencia")}} /> </td>
                  </tr>
                </tbody>
              </table>
              </td>
              <td>
              <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getgrabarPreferencia(det.id_acumulador)}>
                Grabar
              </button>
              <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getEliminarPreferencia(det.id_acumulador)}>
                Eliminar
              </button>

              </td>
            </tr>
          )) :''
      }
      </tbody>
      </React.Fragment>
    )
  }
  render() {
    //<GetUploadImage file_xxx={'app-delivery-8b998-60x60'}  firebase={firebase} getUUID={this.getUUID} width={'60px'} height={'60px'}  token_image={''} />
    //id_datos_empresa, logo, datos_empresa, condiciones
    return(
      <React.Fragment>
      <div className="" style={{"backgroundColor":"white","color":"black"}}>
        <div className="grid-container_">
          <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
          <div className="lbl_text_">Preferencias</div>
        </div>
      </div>
      <div style={{"backgroundColor":"white","height":"100%","color":"black","overflowY": "auto"}}>
        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Campo</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>
            <tr>
              <td>Preferencias</td>
              <td> <input  type="text" value={this.state.new_preferencia}
                onChange={(e) => {this.handleChange_new( e ,"preferencia")}} /> </td>
            </tr>
            <tr>
              <td colSpan="2">
                <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getnewrPreferencia()}>
                  Crear Nueva Preferencia
                </button>
              </td>
            </tr>
          </tbody>
        </table>


        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Información</th>
            <th>Opciones</th>
          </tr>
          </thead>
          {this.llenar_preferencias()}
        </table>
        <br/><br/><br/><br/><br/>
      </div>
      </React.Fragment>
    )
  }
  //cargar_informacion
  componentDidMount (){
    this.cargar_preferencias()
  }

}
export default getPreferencias;
